/* import __COLOCATED_TEMPLATE__ from './contact-section.hbs.js'; */
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Component from '@glimmer/component';
import { PLACEHOLDER_SECTIONS } from '@qonto/ui-kit/constants/pdf-preview';
var _PdfPreviewContactSectionComponent_brand = /*#__PURE__*/new WeakSet();
export default class PdfPreviewContactSectionComponent extends Component {
  constructor(...args) {
    super(...args);
    _classPrivateMethodInitSpec(this, _PdfPreviewContactSectionComponent_brand);
  }
  get organization() {
    return this.args.organization;
  }
  get customerBillingAddress() {
    return _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _getCustomerProperty).call(this, 'billingAddress');
  }
  get organizationAddress() {
    return _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _getOrganizationProperty).call(this, 'address');
  }
  get placeholderConfig() {
    return this.args.placeholderConfig || {};
  }
  get enablePlaceholders() {
    return this.placeholderConfig?.enablePlaceholders;
  }
  get showOrganizationName() {
    return _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _showSectionValue).call(this, 'CONTACT_ORGANIZATION', _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _getOrganizationProperty).call(this, 'legalName'));
  }
  get showOrganizationStreet() {
    return _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _showSectionValue).call(this, 'CONTACT_ORGANIZATION', this.organizationAddress?.firstLine, this.organizationAddress?.secondLine, this.organizationAddress?.thirdLine);
  }
  get showOrganizationCountry() {
    return _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _showSectionValue).call(this, 'CONTACT_ORGANIZATION', this.organizationAddress?.zipcode, this.organizationAddress?.city, this.organizationAddress?.country);
  }
  get showContactEmail() {
    return _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _showSectionValue).call(this, 'CONTACT_ORGANIZATION', this.args.contactEmail);
  }
  get showOrganizationLegalNumber() {
    return _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _showSectionValue).call(this, 'CONTACT_ORGANIZATION', _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _getOrganizationProperty).call(this, 'legalNumber'));
  }
  get showCustomerName() {
    return _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _showSectionValue).call(this, 'CONTACT_CUSTOMER', _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _getCustomerProperty).call(this, 'name'));
  }
  get showCustomerStreet() {
    return _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _showSectionValue).call(this, 'CONTACT_CUSTOMER', this.customerBillingAddress?.streetAddress);
  }
  get showCustomerCountry() {
    return _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _showSectionValue).call(this, 'CONTACT_CUSTOMER', this.customerBillingAddress?.zipCode, this.customerBillingAddress?.city, this.customerBillingAddress?.countryCode);
  }
  get showCustomerEmail() {
    return _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _showSectionValue).call(this, 'CONTACT_CUSTOMER', _assertClassBrand(_PdfPreviewContactSectionComponent_brand, this, _getCustomerProperty).call(this, 'email'));
  }
}
function _getOrganizationProperty(property) {
  return this.organization?.get ? this.organization.get(property) : this.organization?.[property];
}
function _getCustomerProperty(property) {
  return this.args.customer?.get ? this.args.customer.get(property) : this.args.customer?.[property];
}
function _showSectionValue(section, ...values) {
  return !this.enablePlaceholders || this.enablePlaceholders && this.placeholderConfig.activeSections?.includes(PLACEHOLDER_SECTIONS[section]) && values.some(Boolean);
}